<template>
  <div class="box">
    <div class="Bbox"
         style="position: relative;z-index: 999;">
      <div class="top">
        <div class="tit">项目情况</div>
        <div class="border"></div>
        <div class="back"
             @click="back">
          <img src="../../assets/images/back.png"
               alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="content">
        <div class="nav">
          <img class="title"
               @click="lookAll"
               src="../../assets/images/orgTab.png"
               alt="" />
          <div class="navlist">
            <div :class="[selectIndex == index ? 'on' : '', 'item']"
                 v-for="(item, index) in navlist"
                 :key="item.id"
                 @click="change(index, item.id)">
              {{ item.addressName }}
            </div>
          </div>
        </div>
        <div class="list">
          <div class="search">
            <img class="imgicon"
                 src="../../assets/images/hType.png"
                 alt="" />
            <div style="margin-left: 8px; line-height: 68px">服务类别</div>
            <div class="select">
              <el-select v-model="select1"
                         placeholder="请选择"
                         :popper-append-to-body="false"
                         @change="selectChange">
                <el-option v-for="item in selectList1"
                           :key="item.dictId"
                           :label="item.dictName"
                           :value="item.dictId">
                </el-option>
              </el-select>
              <img src="../../assets/images/select_bg.png"
                   alt="" />
            </div>
            <div class="select">
              <el-select v-model="select2"
                         placeholder="请选择"
                         :popper-append-to-body="false">
                <el-option v-for="item in selectList2"
                           :key="item.dictId"
                           :label="item.dictName"
                           :value="item.dictId">
                </el-option>
              </el-select>
              <img src="../../assets/images/select_bg.png"
                   alt="" />
            </div>
            <!-- <div class="select">
              <select
                :class="[select1 == '' ? 'placeholder' : '']"
                v-model="select1"
                @change="selectChange"
              >
                <option value="">请选择</option>
                <option
                  v-for="item in selectList1"
                  :key="item.dictId"
                  :value="item.dictId"
                >
                  {{ item.dictName }}
                </option>
              </select>
              <img src="../../assets/images/select_bg.png" alt="" />
            </div>
            <div class="select">
              <select
                :class="[select2 == '' ? 'placeholder' : '']"
                v-model="select2"
              >
                <option value="">请选择</option>
                <option
                  v-for="item in selectList2"
                  :key="item.dictId"
                  :value="item.dictId"
                >
                  {{ item.dictName }}
                </option>
              </select>
              <img src="../../assets/images/select_bg.png" alt="" />
            </div> -->
            <div class="clear"
                 @click="clear">清空</div>
            <div class="clear clear2"
                 @click="search">搜索</div>
          </div>
          <nav>
            <div :class="[
                select2Index == item.id ? 'on' : '',
                index == 4 ? 'on3' : index == 0 ? 'on2' : '',
                'navitem',
              ]"
                 v-for="(item, index) in nav2list"
                 :key="index"
                 @click="change2(index, item.id)">
              {{ item.name }}({{ item.num }})
            </div>
          </nav>
          <template v-if="list.length>0">
            <div :class="[item.value < 3 ? 'warn' : '', 'item']"
                 v-for="item in list"
                 :key="item.id"
                 @click="GoDetail(item.id)">
              <div class="left">
                <div class="leftTop">
                  {{ item.projectName }}
                </div>
                <div class="leftBom">
                  <div class="leftBom1">
                    <img class="icon"
                         src="../../assets/images/icon.png"
                         alt="" />
                    {{ item.govName }}
                  </div>
                  <div class="leftBom2">
                    <img class="icon"
                         src="../../assets/images/icon2.png"
                         alt="" />
                    {{ item.orgName }}
                  </div>
                </div>
              </div>
              <div class="right"
                   v-if="item.projectStartStatus == 1 && item.projectStatus == 3">
                <span class="num">已超期</span>
                <div class="warn2">
                  <img src="../../assets/images/warn.png"
                       alt="" />
                </div>
              </div>
            </div>
          </template>
          <div v-else
               style="color:#FFE1CE;font-size:30px;font-weight:600;margin-top: 200px;text-align: center;">暂无相关数据</div>
          <Pagination v-if="total>0"
                      ref="pagination"
                      :total="total"
                      :size="5"
                      :page.sync="page"
                      @pagination="changePage" />
        </div>
      </div>
    </div>
    <div class="bg"></div>
  </div>
</template>
<script>
import Pagination from "@/components/pagination";
export default {
  data () {
    return {
      select1: "",
      select2: "",
      selectList1: [],
      selectList2: [],
      selectIndex: -999,
      id: "",
      select2Index: 0,
      projectStatus: "",
      page: 1,
      total: 0,
      navlist: [],
      nav2list: [
        { name: "全部", id: "", num: 0 },
        { name: "未开始", id: 1, num: 0 },
        { name: "报名中", id: 2, num: 0 },
        { name: "执行中", id: 3, num: 0 },
        { name: "已结项", id: 4, num: 0 },
      ],
      list: [],
    };
  },

  components: {
    Pagination,
  },

  computed: {},

  create () { },

  mounted () {
    this.getnavList();
    this.getSelectList();
  },

  methods: {
    // 返回
    back () {
      this.$router.go(-1);
    },
    // 获取侧边栏列表
    getnavList () {
      let url =
        this.$baseUrl +
        "/system/sysAddressController/selecteAddressByCityTeamWork";
      let postData = {
        parentId: 330102,
      };
      this.postRequest(url, postData)
        .then((res) => {
          this.navlist = res.data;
          this.getList();
        })
        .catch(() => { });
    },
    // 获取下拉菜单列表
    getSelectList () {
      let url = this.$baseUrl + "/system/dictController/queryDictByKeyParent";
      let postData = {
        key: "serviceType",
      };
      this.postRequest(url, postData)
        .then((res) => {
          this.selectList1 = res.data;
          this.select2 = "";
        })
        .catch(() => { });
    },
    // 改变一级服务类别
    selectChange () {
      this.getSelectList2();
      this.select2 = "";
    },
    // 获取二级服务类别列表
    getSelectList2 () {
      let url = this.$baseUrl + "/system/dictController/queryDictByKeyParent";
      let postData = {
        key: "projectCategory",
        parentId: this.select1,
      };
      this.postRequest(url, postData)
        .then((res) => {
          this.selectList2 = res.data;
        })
        .catch(() => { });
    },
    // 切换页码
    changePage (page) {
      this.page = page;
      this.getList();
    },
    // 获取数据列表
    getList () {
      let url =
        this.$baseUrl + "/teamword/wechat/kyyProject/selectKyyProjectByGovId";
      let postData = {
        page: this.page,
        limit: 5,
        street: this.id,
        projectStatus: this.projectStatus,
        projectServiceType: this.select1,
        projectCategory: this.select2,
      };
      this.postRequest(url, postData)
        .then((res) => {
          this.list = res.data.pageInfo.list;
          this.total = res.data.pageInfo.total;
          this.nav2list[0].num = res.data.all;
          this.nav2list[1].num = res.data.noStart;
          this.nav2list[2].num = res.data.signUp;
          this.nav2list[3].num = res.data.execution;
          this.nav2list[4].num = res.data.knot;
        })
        .catch(() => { });
    },
    // 切换侧边栏
    change (index, id) {
      this.selectIndex = index;
      this.page = 1;
      this.id = id;
      this.getList();
    },
    // 切换项目状态
    change2 (index, id) {
      this.select2Index = index;
      this.projectStatus = id;
      this.page = 1;
      this.getList();
    },
    //清空select选择 然后刷新列表
    clear () {
      this.select1 = "";
      this.select2 = "";
      this.page = 1;
      this.getList();
    },
    // 搜索
    search () {
      this.page = 1;
      this.getList();
    },
    // 去详情
    GoDetail (id) {
      this.$router.push({ path: "/projectDetails", query: { id } });
    },
    lookAll () {
      this.selectIndex = -999;
      this.page = 1;
      this.id = "";
      this.getList();
    },
  },
};
</script>
<style lang='less' scoped>
.box {
  width: 100%;
  height: 100%;
  background: #000;
  position: relative;
  .top {
    height: 92px;
    overflow: hidden;
    position: relative;
    background: url("../../assets/images/pageHome/topTitle.png") no-repeat
      center/100% 100%;
    .tit {
      height: 33px;
      width: 300px;
      line-height: 33px;
      margin-top: 23px;
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #fff;
      // background: linear-gradient(184deg, #ffe01a 0%, #be8840 100%);
      -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
      margin-left: 887px;
    }
    .back {
      position: absolute;
      top: 31px;
      right: 43px;
      font-size: 24px;
      font-weight: 400;
      color: #1080d0;
      cursor: pointer;
      img {
        width: 20px;
        height: 21px;
        margin-right: 9px;
      }
    }
  }
  .content {
    display: flex;
    .nav {
      margin-left: 32px;
      margin-top: 3px;
      .title {
        width: 198px;
        display: block;
        height: 90px;
        cursor: pointer;
      }
      .navlist {
        margin-top: -5px;
        padding: 18px 0;
        background: url("../../assets/images/orgTaber.png") no-repeat
          center/100% 100%;
        width: 196px;
        // height: 100%;
        height: 818px;
        .on {
          color: #ffffff !important;
        }
        .item {
          width: 190px;
          text-align: center;
          cursor: pointer;
          margin-bottom: 33px;
          height: 23px;
          line-height: 24px;
          font-size: 24px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }
    .list {
      width: 1630px;
      // width: 85%;
      height: 940px;
      margin: 6px 0 0 20px;
      // background: rgba(192, 103, 25, 0.17);
      // border-radius: 10px;
      .search {
        display: flex;
        height: 68px;
        background: #08223e;
        // border: 1px solid #f7ccab;
        border-radius: 10px;
        font-size: 24px;
        font-weight: bold;
        color: rgba(255, 255, 255, 0.9);
        // width: 1454px;
        width: 100%;
        .imgicon {
          width: 17px;
          height: 40px;
          margin: 24px 0 0 21px;
        }
        .select {
          width: 190px;
          height: 40px;
          position: relative;
          margin: 14px 0 0 10px;
          /deep/ .el-input__inner {
            background: #07111e;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            border: none;
            .el-input {
              font-size: 22px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
            }
          }
          /deep/ .el-select-dropdown {
            background: #251403;
            font-size: 22px;
            font-weight: 400;
            color: #ffffff;
            left: 0 !important;
            margin-top: 0px !important;
            border: 0;
            border-radius: 0;
            .el-select-dropdown__item {
              font-size: 22px;
              font-weight: 400;
              color: #ffffff;
            }
            .el-select-dropdown__item.hover {
              background: #07111e;
            }
          }
          /deep/ .el-popper .popper__arrow {
            display: none;
          }
          /deep/ .el-input__suffix {
            display: none;
          }
          select {
            width: 190px;
            height: 40px;
            background: #07111e;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            padding-left: 10px;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            option {
              background: #251403;
              font-size: 22px;
              font-weight: 400;
              color: #ffffff;
            }
          }
          .placeholder {
            color: rgba(255, 255, 255, 0.5);
          }
          img {
            position: absolute;
            right: 10px;
            top: 15px;
            width: 11px;
            height: 7px;
            pointer-events: none;
          }
        }
        .clear {
          width: 72px;
          height: 40px;
          background: linear-gradient(0deg, #064085, #0e69e4);
          // border: 1px solid;
          border-image: linear-gradient(
              180deg,
              rgba(140, 64, 4, 0.7),
              rgba(249, 213, 185, 0.7)
            )
            1 1;
          opacity: 0.8;
          border-radius: 5px;
          font-size: 22px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          opacity: 0.8;
          text-align: center;
          line-height: 40px;
          margin-top: 14px;
          margin-left: 20px;
          cursor: pointer;
        }
        .clear2 {
          margin-left: 10px;
          background: linear-gradient(0deg, #064085, #0e69e4);
          border-image: linear-gradient(
              180deg,
              rgba(140, 64, 4, 0.7),
              rgba(249, 213, 185, 0.7)
            )
            1 1;
        }
      }
      nav {
        display: flex;
        margin: 20px 0;
        .navitem {
          width: 326px;
          height: 79px;
          // background: url("../../assets/images/navBg2.png") no-repeat center/100% 100%;
          background: linear-gradient(0deg, #064085, #0e69e4);
          border: 1px solid;
          font-size: 32px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          line-height: 79px;
          text-align: center;
          cursor: pointer;
          overflow: hidden;
          border-top: 0;
          border-bottom: 0;
        }
        .on {
          font-size: 34px;
          font-weight: bold;
          color: #ffffff;
          background: #092f5d;
          box-shadow: 0px 2px 2px 0px #082b52;
          opacity: 0.8;
          border-top: 0;
          border-bottom: 0;
        }
        .on2 {
          border-radius: 14px 0px 0px 0;
          border: 1px solid;
          border-top: 0;
          border-bottom: 0;
        }
        .on3 {
          border: 1px solid;
          border-radius: 0px 14px 0px 0px;
          border-top: 0;
          border-bottom: 0;
        }
      }
      .item {
        height: 103px;
        margin-bottom: 20px;
        display: flex;
        background: url("../../assets/images/itemBg1.png") no-repeat center/100%
          100%;
        padding-left: 30px;
        position: relative;
        margin-left: 23px;
        margin-right: 12px;
        cursor: pointer;
        .left {
          .leftTop {
            margin-top: 21px;
            height: 28px;
            font-size: 28px;
            line-height: 28px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
          }
          .leftBom {
            display: flex;
            .leftBom1 {
              width: 600px;
              margin-top: 14px;
              line-height: 20px;
              height: 20px;
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #fffaf0;
              .icon {
                width: 20px;
                height: 19px;
                margin-right: 7px;
                transform: translateY(2px);
              }
            }
            .leftBom2 {
              margin-top: 14px;
              line-height: 20px;
              height: 20px;
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #fffaf0;
              .icon {
                width: 20px;
                height: 19px;
                margin-right: 7px;
                transform: translateY(2px);
              }
            }
          }
        }
        .center {
          font-size: 28px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.4);
          display: flex;
          line-height: 0;
          align-items: center;
          height: 60px;
          width: 736px;
        }
        .right {
          font-size: 28px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.4);
          display: flex;
          line-height: 107px;
          height: 107px;
          position: absolute;
          right: 0;
          .num {
            font-size: 40px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
            height: 40px;
            line-height: 103px;
          }
          .warn2 {
            width: 83px;
            height: 103px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 16px;
            img {
              width: 38px;
              height: 35px;
            }
          }
        }
      }
      .warn {
        background: url("../../assets/images/itemBg2.png") no-repeat center/100%
          100%;
      }
    }
  }
  .bg {
    // width: 1782px;
    // height: 1000px;
    // background: url("../../assets/images/nrq.png") no-repeat center/100% 100%;
    // position: absolute;
    // right: -4px;
    // bottom: 0;

    width: 1630px;
    height: 850px;
    background: url("../../assets/images/nrq.png") no-repeat center/100% 100%;
    position: absolute;
    right: 40px;
    bottom: 45px;
  }
}
</style>